import { gte, lte, overEvery } from 'lodash/fp';

export const validateDateRange = (minDate: $TSFixMe, maxDate: $TSFixMe) => overEvery([lte(minDate), gte(maxDate)]);
